export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["DEBUG"] = 3] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["ERROR"] = 1] = "ERROR";
})(LogLevel || (LogLevel = {}));
export class Logger {
    constructor(options) {
        this.options = options;
    }
    debug(...args) {
        this._log(LogLevel.DEBUG, ...args);
    }
    log(...args) {
        this._log(LogLevel.INFO, ...args);
    }
    error(...args) {
        this._log(LogLevel.ERROR, ...args);
    }
    _log(level, ...args) {
        if (this.options.logLevel >= level) {
            const message = args.shift();
            const fn = level === LogLevel.ERROR ? console.error : console.info;
            fn.call(console, `[${this.options.service} ${this.options.prefix}] ${message}`, ...args);
        }
    }
}
